<mat-form-field class="fk-w-full" [appearance]="appearance">
  <!-- label -->
  <mat-label>
    <base-form-kit-label [label]="label">
      <ng-content select="[label-content]"></ng-content>
    </base-form-kit-label>
  </mat-label>

  <div>
    <input
      matInput
      [disabled]="isDisabled"
      [ngxTimepicker]="timePicker"
      [formControl]="control || defaultControl"
      [format]="24"
      [(ngModel)]="value"
      (ngModelChange)="emit()"
      [min]="_min"
      [max]="_max"
      [ngStyle]="{
        'font-size': fontSize
      }"
      (change)="setManualValue($event)"
    />
  </div>

  <div class="fk-items-center" matSuffix>
    <mat-icon>
      <ngx-material-timepicker-toggle
        [for]="timePicker"
        [style.display]="isShowToggle ? 'initial' : 'none'"
      ></ngx-material-timepicker-toggle>
    </mat-icon>

    <validation-icon
      [control]="control"
      [hasMatPrefix]="hasMatPrefix"
      [hasMatSuffix]="hasMatSuffix"
      [value]="value"
      [isShowValidationStatusIcon]="isShowValidationStatusIcon"
    >
    </validation-icon>
  </div>
</mat-form-field>

<ngx-material-timepicker
  #timePicker
  [appendToInput]="true"
  [defaultTime]="value"
  [cancelBtnTmpl]="cancelBtnTimePiker"
  [confirmBtnTmpl]="confirmBtnTimePiker"
></ngx-material-timepicker>

<!-- time piker buttons -->
<ng-template #cancelBtnTimePiker>
  <button [class]="'fk-btn fk-btn-light fk-w-75px fk-mx-1 ' + (cancelBtnClass || '')">
    {{ "common.cancel" | translate }}
  </button>
</ng-template>
<ng-template #confirmBtnTimePiker>
  <button
    [class]="'fk-btn fk-w-75px fk-mx-1 ' + (confirmBtnClass || 'fk-btn-primary')"
  >
    {{ "common.confirm" | translate }}
  </button>
</ng-template>
